export function InitiateTutorial(props) {
  const {header, text, setTutorial} = props;
  return (
    <div className="popup-overlay" 
      // style={{display: 'flex', alignItems: "center", justifyContent:"center"}}
    >
      <div className="initiate-tutorial">
        <div 
          className="initiate-tutorial__header"
          style={{fontWeight: "bold", fontSize: "20px", marginBottom: "10px"}}
        >{header}</div>
        <div className="initiate-tutorial__text">{text}</div>
        <div 
          className="initiate-tutorial__buttons"
          style={{display: "flex", justifyContent:"center", gap: "20px", marginTop: "10px"}}
        >
          <button className="initiate-tutorial__button btn" onClick={() => setTutorial(0)}>Cancel</button>
          <button className="initiate-tutorial__button btn gradient" onClick={() => setTutorial(2)}>Start</button>
        </div>
      </div>
    </div>
  )
}

export function ActionDescription(props) {
  const {
    text, 
    style, 
    triangle, 
    hidePopup, 
    close, 
    setTutorial, 
    tutorial, 
    next,
    finish
  } = props;
  // style: left/right, top/bottom, width
  // triangle: left/right, top/bottom (-18px)
  return (
    <>
      <div className="action-description" style={style}>
        <div className="action-description__triangle" style={triangle}></div>
        <div className="action-description__text">{text}</div>
        <div className="action-description__buttons" style={{display: "flex", justifyContent:"flex-end"}}>
          {close && !finish &&
            <div 
              className="action-description__close btn" 
              onClick={() => setTutorial(0)}
              style={{
                fontSize: "12px", 
                backgroundColor: "#EFEFEF", 
                width: "fit-content",
                marginTop: "5px",
                cursor: "pointer"
              }}
            >{close}</div>
          }
          {next && 
            <div 
              className="action-description__close btn" 
              onClick={() => setTutorial(tutorial+1)}
              style={{
                fontSize: "12px", 
                backgroundColor: "#EFEFEF", 
                width: "fit-content",
                marginTop: "5px",
                cursor: "pointer"
              }}
            >{next}</div>
          }
          {finish && 
            <div 
              className="action-description__close btn" 
              onClick={finish}
              style={{
                fontSize: "12px", 
                backgroundColor: "#EFEFEF", 
                width: "fit-content",
                marginTop: "5px",
                cursor: "pointer"
              }}
            >Finish</div>
          }
        </div>
      </div>
      {!hidePopup && 
        <div className="popup-overlay">
        </div>
      }
    </>
  )
}

export function demoDashboardData(numPoints = 30, numRewards = 6, days = 7) {
  // Helper to generate a random integer between min and max, inclusive
  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  
  // Helper to generate a random date string between two dates (formatted as "YYYY-MM-DD")
  function randomDate(start, end) {
    const date = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  
  // Date range for generating dates
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1);
  
  // Possible actions for "points" data
  const pointActions = [
    "Order Placed",
    "Email Subscribed",
    "Birthday Reward",
    "Account Created",
    "Reward Redeemed"
  ];
  
  // Generate the "points" array
  const points = [];
  for (let i = 0; i < numPoints; i++) {
    const action = pointActions[randomInt(0, pointActions.length - 1)];
    const date = randomDate(startDate, endDate);
    let pts, count, subtotal, discounted;
    
    // Set values based on action type
    switch (action) {
      case "Order Placed":
        pts = randomInt(3000, 5000);
        count = randomInt(50, 100);
        subtotal = parseFloat((Math.random() * 1000 + 100).toFixed(2));
        discounted = randomInt(0, 50);
        break;
      case "Email Subscribed":
        pts = randomInt(2000, 4000);
        count = randomInt(80, 120);
        subtotal = 0;
        discounted = 0;
        break;
      case "Birthday Reward":
        pts = randomInt(100, 600);
        count = 1;
        subtotal = 0;
        discounted = 0;
        break;
      case "Account Created":
        pts = randomInt(150, 400);
        count = randomInt(1, 10);
        subtotal = 0;
        discounted = 0;
        break;
      case "Reward Redeemed":
        pts = -randomInt(100, 1500);
        count = randomInt(1, 10);
        subtotal = 0;
        discounted = 0;
        break;
      default:
        pts = 0;
        count = 0;
        subtotal = 0;
        discounted = 0;
    }
    
    points.push({
      Date: date,
      Action: action,
      Points: pts,
      Count: count,
      Subtotal: subtotal,
      Discounted: discounted
    });
  }
  
  // For "rewards", we'll define a list of reward IDs and corresponding descriptions.
  const rewardIDs = [
    "634c8b7b77e5bed9669458df",
    "634c8b2b77e5bed9669458d5",
    "634c86c8aa5e8546edc3335f",
    "634c8ba377e5bed9669458e5"
  ];
  const allRewards = {
    "634c8b7b77e5bed9669458df": "$20 off",
    "634c8b2b77e5bed9669458d5": "$10 off",
    "634c86c8aa5e8546edc3335f": "$5 off",
    "634c8ba377e5bed9669458e5": "$50 off"
  };
  
  // Generate the "rewards" array
  // For rewards, we'll randomly choose an action ("Order Placed" or "Reward Redeemed"),
  // select a random reward ID, and generate count, subtotal, and discounted.
  const rewards = [];
  for (let i = 0; i < numRewards; i++) {
    const rewardAction = Math.random() < 0.5 ? "Order Placed" : "Reward Redeemed";
    const rewardId = rewardIDs[randomInt(0, rewardIDs.length - 1)];
    const count = randomInt(1, 10);
    let subtotal = 0;
    let discounted = 0;
    if (rewardAction === "Order Placed") {
      subtotal = parseFloat((Math.random() * 100 + 10).toFixed(2));
      discounted = randomInt(0, 20);
    }
    rewards.push({
      Action: rewardAction,
      Reward: rewardId,
      Count: count,
      Subtotal: subtotal,
      Discounted: discounted
    });
  }
  
  return {
    points,
    rewards,
    all_rewards: allRewards
  };
}